import {ChangeDetectorRef, Component, effect, EventEmitter, inject, input, Input, OnInit, Output, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {
  IonButton, IonButtons, IonCard, IonDatetime,
  IonIcon, IonImg,
  IonInput, IonItem, IonLabel, IonModal, IonRadio, IonRadioGroup, IonSegment, IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonTextarea, ModalController
} from "@ionic/angular/standalone";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {CommonService} from "../../../core/common.service";
import {
  components,
  contactFormSubjectList, dateFormat,
  errorMessages,
  formTypes, formTypesNames, loaderMessages,
  messagesColor
} from "../../../configs/config";
import {AlertService} from "../../../core/alert.service";
import {PropertyService} from "../../../properties/property.service";
import {LanguageService} from '../../../core/language.service';
import {ContactSuccessComponent} from '../contact-success/contact-success.component';
import {SelectCountryComponent} from './select-country/select-country.component';
import {GoogleMap, MapGeocoder, MapMarker} from '@angular/google-maps';
import {mapStyle} from '../../../properties/common/mapStyle';
import {environment} from '../../../../environments/environment';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {addIcons} from 'ionicons';
import {documentTextOutline} from 'ionicons/icons';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    IonButton,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonTextarea,
    ReactiveFormsModule,
    IonIcon,
    IonCard,
    IonSegment,
    IonSegmentButton,
    FormsModule,
    IonLabel,
    SelectCountryComponent,
    GoogleMap,
    MapMarker,
    IonButtons,
    IonDatetime,
    IonModal,
    IonRadio,
    IonRadioGroup,
    IonImg,
    IonItem,
    TranslateModule
  ],
  providers: [DatePipe]
})
export class ContactFormComponent  implements OnInit {


  feedbackForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    rating: new FormControl(0, Validators.required),
    message: new FormControl(''),
  });


  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    subject: new FormControl('', Validators.required),
    message: new FormControl(''),
  });


  complaintsForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    message: new FormControl(''),
  });

  b2cForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    leaseDuration: new FormControl('', Validators.required),
    moveInDate: new FormControl('', Validators.required),
    message: new FormControl(''),
  });

  b2bForm = new FormGroup({
    name: new FormControl('', Validators.required),
    companyName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    contactNumber: new FormControl('', Validators.required),
    propertyAddress: new FormControl('', Validators.required),
    propertyType: new FormControl('', Validators.required),
    noOfUnits: new FormControl(),
    message: new FormControl(''),
    pdfPath: new FormControl(''),
  });
  commonService: CommonService = inject(CommonService);
  propertyService: PropertyService = inject(PropertyService);
  categories: any = [];
  alertService: AlertService = inject(AlertService);
  @Input() formType: string = formTypes.contact;
  @Output() formRatedEvent = new EventEmitter<boolean>();
  @Output() formSubmittedEvent = new EventEmitter<boolean>();
  hideTab = input<boolean>(false);
  formsMap = {
    [formTypes.contact]: this.contactForm,
    [formTypes.b2b]: this.b2bForm,
    [formTypes.b2c]: this.b2cForm,
    [formTypes.feedback]: this.feedbackForm,
    [formTypes.complaints]: this.complaintsForm,
  };
  currentForm: FormGroup = this.formsMap[formTypes.contact];
  pdfFile: any;
  languageService: LanguageService = inject(LanguageService);
  formTextContent: any;
  modalController: ModalController = inject(ModalController);
  prefix: string = '+966';
  coordinates: google.maps.LatLngLiteral | any = { lat:	24.774265, lng: 46.738586 };
  mapOptions: any = {
    styles: mapStyle.style,
    mapId: environment.mapId,
    disableDefaultUI: true,
    zoomControl: true
  };
  hideFeedbackForm: boolean = true;
  @Input() b2bOnly: boolean = false;
  markerOptions: any = { draggable: true };
  cds: ChangeDetectorRef = inject(ChangeDetectorRef);
  constructor() {
    addIcons({ documentTextOutline })
    effect(async () => {
      if (this.languageService.lang()) {
        this.formTextContent = await this.languageService.loadContent(components.forms);
      }
    });
  }

  async ngOnInit() {
    if (formTypes.b2b === this.formType) {
      this.categories = await this.propertyService.getSubCategories();
    }
    this.formTextContent = await this.languageService.loadContent(components.forms);
    this.updateForm();
  }
  dataPipe: DatePipe = inject(DatePipe);
  datePicked($event: any) {
    const date = this.dataPipe.transform($event.detail.value, dateFormat);
    this.b2cForm.controls.moveInDate.patchValue(date);
  }
  async showSuccessMessage(message?: string) {
    const modal = await this.modalController.create({
      component: ContactSuccessComponent,
      componentProps: {message},
      cssClass: 'modal-success',
    });
    await modal.present();
  }

  updateForm() {
    this.currentForm = this.formsMap[this.formType] || this.formsMap[formTypes.contact];
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  router: Router = inject(Router);
  isSuccess: boolean = false;
  async sendRequest() {
    console.log(this.formType);
    console.log(this.currentForm.value);
    if (this.currentForm.invalid) {
      this.currentForm.markAllAsTouched();
      this.validateAllFormFields(this.currentForm);
      await this.alertService.showToast(messagesColor.error, errorMessages.fillAllTheFields);
      return;
    }
    if (this.formType === formTypes.b2b && !this.isMarkerChanged) {
      await this.alertService.showToast(messagesColor.error, 'Please set the location of the property');
      return;
    }
    try {
      await this.alertService.showLoader(loaderMessages.message);
      const data: any = this.currentForm.value;
      data.formType = this.formType;
      data.contactNumber = this.prefix + data.contactNumber;
      if (data.formType === 'b2b') {
        try {
          const res: any = await this.commonService.uploadPDF(this.pdfFile);
          console.log(res);
          if (res.message.file) {
            data.pdfPath = res.message.file.filepath;
          }
        } catch (error) {}
      }
      await this.commonService.sendEnquire(data);
      this.alertService.dismissLoader();
      if (this.formType !== formTypes.feedback) {
        await this.router.navigate(['/thank-you', data.formType]);
        this.pdfFile = null;
      } else {
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
          this.formSubmittedEvent.emit(true);
        }, 3000);
        // this.showSuccessMessage()
      }
      this.currentForm.reset();
    } catch (error) {
      this.alertService.dismissLoader();
      await this.alertService.showToast(messagesColor.error, this.formTextContent?.formErrorMessages.success);
    }
  }

  protected readonly formTypes = formTypes;
  protected readonly errorMessages = errorMessages;
  protected readonly contactFormSubjectList = contactFormSubjectList;

  async fileSelected($event: any) {
    try {
      this.pdfFile = $event.target.files[0];
      console.log(this.pdfFile);
    } catch (error) {}
  }
  countrySelected($event: any) {
    this.prefix = $event;
    this.cds.detectChanges();
  }
  isMarkerChanged: boolean = false;
  mapMarkerChanged($event: any) {
    const latLng = $event.latLng;
    this.isMarkerChanged = true;
    this.geocodeLatLng({lat: latLng.lat(), lng: latLng.lng()});
  }

  validateNumber(event: any): void {
    const inputValue = event.target.value;
    this.currentForm.controls['contactNumber'].setValue(inputValue.replace(/[^0-9]/g, ''));
  }
  markerInitialized($event: any) {
    const latLng = $event.position;
    this.geocodeLatLng({lat: latLng.lat(), lng: latLng.lng()});
  }
  geocodeLatLng(position: google.maps.LatLngLiteral) {
    console.log('address', position);
    this.geocode(position, 'en');
    // this.geocode(position, 'ar');
  }

  geocoder: MapGeocoder = inject(MapGeocoder);
  private geocode(
    position: google.maps.LatLngLiteral,
    language: string,
  ) {
    this.geocoder
      .geocode({ location: { lat: position.lat, lng: position.lng }, language })
      .subscribe(({ results }: any) => {
        const formattedAddress = results[0].formatted_address;
        console.log(formattedAddress);
        console.log(results);
        this.b2bForm.controls.propertyAddress.setValue(formattedAddress);
      });
  }


  protected readonly formTypesNames = formTypesNames;

  feedbackSelected(x: number) {
    console.log('feedbackSelected', x);
    this.formRatedEvent.emit(true);
    this.hideFeedbackForm = false;
    this.feedbackForm.controls.rating.patchValue(x);
  }
}
